import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Box, InputBase, Typography, ListItem, CircularProgress } from '@material-ui/core';
import { Delete, Search, Add, } from '@material-ui/icons'
import { useDataProvider, useTranslate, usePermissions } from 'react-admin';
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core/styles'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import colors from '../CustomizedUIs/Colors'
import { red, pink, grey } from '@material-ui/core/colors';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import CustomTextFiled from '../users/CustomTextField'
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import TextButton from '../CustomizedUIs/TextButton';
import { useHistory } from 'react-router';
const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    popover: {
        position: 'relative',
        marginLeft: '1em'
    },
    header: {
        zIndex: 2,
        position: 'relative',
        WebkitBoxShadow: ' 0px 5px 5px 0px rgba(0,0,0,0.2)',
        MozBoxShadow: '0px 5px 5px 0px rgba(0,0,0,0.2)',
        boxShadow: '0px 5px 5px 0px rgba(0,0,0,0.2)',
    },
    textClose: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.4px',
        color: '#4f5064',
    }, btnClose: {
        width: '25px',
        height: '25px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
    },
    titleCluster: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
    textLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: ' #88898c',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#eb5a4d !important',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextSearch: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#88898c',
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    TextCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#ffffff',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 8,

    },
    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: 4,
    },

    btnCreateCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '13px 16px 13px 16px',

    },
    link: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        textDecoration: 'underline',

    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
}));


const CreateInSelect = ({ name, handelCreateNew, clickOpenCreate, openCreate, handelCancelCreate, onChangValueInput, valueInput }) => {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <Box>
            {
                openCreate ?
                    (
                        <Box display='flex' style={{ boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.3)', backgroundColor: '#237fc2' }} px={2} py={1}>
                            <InputBase
                                value={valueInput}
                                onChange={onChangValueInput}
                                placeholder={translate(`pos.dashboard.nameAreNew`) + " " + name}
                                inputProps={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                        paddingLeft: '5px',
                                        borderRadius: '2px',
                                        fontFamily: 'UniviaPro',
                                        fontSize: '12px',
                                        fontWeight: 'normal',
                                        fontStretch: 'normal',
                                        fontStyle: 'normal',
                                        lineHeight: 2,
                                        letterSpacing: '0.12px',
                                        color: '#ffffff',
                                        opacity: '0.15px',
                                        borderRadius: '2px',
                                    }
                                }}
                                style={{ width: '240px' }}
                            />
                            <Button disabled={valueInput.length === 0} style={{ backgroundColor: 'white', margin: '0 1em' }} color='primary' size='small' onClick={() => handelCreateNew(valueInput)}>
                                <Typography className={classes.btnCreate} >{translate(`pos.dashboard.createNew`) + " " + name}</Typography>
                            </Button>
                            <Box display='flex' alignItems='center'>
                                <TextButton onClick={handelCancelCreate} />
                            </Box>
                        </Box>
                    )
                    :
                    (
                        <Box display='flex' alignItems='center' alignContent='center' bgcolor='#237fc2' boxShadow='0 1px 10px 0 rgba(0, 0, 0, 0.3)' px={3} py={1} style={{ cursor: !openCreate ? 'pointer' : 'none' }} onClick={clickOpenCreate}>
                            <Typography className={classes.TextCreate} style={{ margin: 'auto 0' }}>{translate(`pos.dashboard.createNew`)}</Typography>
                            <Add style={{ color: 'white', marginLeft: 5, width: '13px', height: '13px' }} />
                        </Box>

                    )
            }
        </Box>
    )
}

const FilterInput = ({ onChangeValue, value, name, open }) => {
    const classes = useStyles()
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    return (
        <Box width={200} display='flex' style={{ borderRadius: '8.1px', border: 'solid 0.8px #f1f2f4', backgroundColor: '#f7f7f7' }}>
            <Search style={{ color: '#b4b5bd', size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                autoFocus={open ? true : false}
                value={value}
                onChange={onChangeValue}
                placeholder={"Filter " + name}
                inputProps={{
                    'aria-label': 'search',
                    className: classes.TextSearch
                }}
                style={{ width: '180px' }}
            />
        </Box>
    )
}

const General = ({ readOnly, open, setDeleted, handleClose, dataRecever, clusterData, ...props }) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const { permissions, loaded } = usePermissions();
    const history =useHistory()
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState(dataRecever);

    const [clusterName, setClusterName] = useState('');
    const [cluster, setCluster] = useState('');
    const [group, setGroup] = useState('');
    const [entity, setEntity] = useState('');
    const [infoPage, setInfoPage] = useState('');
    const [disabledEntity, setdisabledEntity] = useState(false);
    const [openClusters, setOpenClusters] = useState(false);
    const [openGroup, setOpenGroup] = useState(false);
    const [openEntity, setOpenEntity] = useState(false);
    const [openInfoPage, setOpenInfoPage] = useState(false);
    const [openCreateEntity, setCreateOpenEntity] = useState(false);
    const [openCreateGroup, setCreateOpenGroup] = useState(false);
    const [error, setError] = React.useState("");
    const [valueNewEntity, setValueNewEntity] = useState("");
    const [valueNewGroup, setValueNewGroup] = useState("");
    const [openTooltip, setTooltip] = React.useState(false);
    const [infopages, setInfopages] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [filterInfopage, setFilterInfopage] = useState('')
    const [filterCluster, setFilterCluster] = useState('');
    const [filterGroup, setFilterGroup] = useState('');
    const [filterEntity, setFilterEntity] = useState('');

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);

    const classes = useStyles()


    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false)
    }

    const handleOpenConfirmDialog = () => {
        setOpenConfirmDialog(true)
    }

    const handleDeleteCluster = () => {
        dataProvider('DELETE', 'clusters', {
            id: clusterData.id
        }).then(response => {
            handleCloseConfirmDialog()
            //setDeleted(clusterData)
            //handleClose()
            props.history.push({
                pathname: '/',
                state: {
                    openMessage: true,
                    cluster: clusterData
                }
            })

        }).catch(error => {
            setError(translate(`resoures.room.deleteFailed`))
            handleCloseConfirmDialog()
        })

    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };




    //event onChang Name TextField
    const onChangeName = (e) => {
        setClusterName(e.target.value)
    }
    //----


    //--Event add new Entity
    const onCreateNewEntity = (value) => {

        var temps = data
        temps.countResult.entities.unshift({
            groupCount: 0,
            name: value,
            clusters: 0
        })
        setEntity(value)
        setData(temps)
        setCreateOpenEntity(false)
        setValueNewEntity('')
        setOpenEntity(false)
    }

    const onChangNewValueEntity = (e) => {
        setValueNewEntity(e.target.value)

    }

    const onChangeFilterInfopage = (e) => {
        setFilterInfopage(e.target.value)
    }


    const clickOpenCreateEntity = () => {
        setCreateOpenEntity(true)
    }

    const handelCancelCreateEntity = () => {
        setCreateOpenEntity(false)
    }
    //-------------------------------------



    //--Event add new Group
    const onCreateNewGroup = (value) => {
        var temps = data
        temps.countResult.groups.unshift({
            clusters: 0,
            entity: '',
            name: value
        })
        setGroup({
            clusters: 0,
            entity: '',
            name: value
        })
        setdisabledEntity(false)

        setData(temps)
        setCreateOpenGroup(false)
        setValueNewGroup('')
        setOpenGroup(false)
    }

    const onChangNewValueGroup = (e) => {
        setValueNewGroup(e.target.value)

    }

    const clickOpenCreateGroup = () => {
        setCreateOpenGroup(true)
    }

    const handelCancelCreateGroup = () => {
        setCreateOpenGroup(false)
    }
    //-------------------------------------




    //event select of Cluster
    const onChangeCluster = (cluster) => {
        setCluster(cluster)
        setEntity(cluster.entity)
        setGroup({
            name: cluster.group,
            entity: cluster.entity
        })
        setdisabledEntity(true)

        setOpenClusters(false)
    }

    const handleClickOpenCluster = () => {
        setOpenClusters(!openClusters)
        setOpenGroup(false)
        setOpenEntity(false)
        setOpenInfoPage(false)
        setOpenPopper(false)
    }
    const onChangeFilterCluster = (e) => {
        setFilterCluster(e.target.value)
    }
    //----------------------



    //event select of Group
    const onChangeGroup = (value) => {
        setGroup(value)
        setEntity(value.entity)
        setdisabledEntity(value.entity != "")

        setOpenGroup(false)
    }

    const handleClickOpenGroup = () => {
        setOpenGroup(!openGroup)
        setOpenEntity(false)
        setOpenClusters(false)
        setOpenInfoPage(false)
        setOpenPopper(false)
    }

    const onChangeFilterGroup = (e) => {
        setFilterGroup(e.target.value)
    }
    //----------------------




    //event select off Entity
    const onChangeEntity = (name) => {
        setEntity(name)
        setOpenEntity(false)
    }

    const handleClickOpenEntity = () => {
        setOpenEntity(!openEntity)
        setOpenGroup(false)
        setOpenClusters(false)
        setOpenInfoPage(false)
        setOpenPopper(false)
    }
    const onChangeFilterEntity = (e) => {
        setFilterEntity(e.target.value)
    }
    //----------------------



    // //event select off InfoPage
    const onChangeInfoPage = (name) => {
        setInfoPage(name)
        setOpenInfoPage(false)
    }

    const handleClickOpenInfoPage = () => {
        setOpenInfoPage(!openInfoPage)
        setOpenGroup(false)
        setOpenClusters(false)
        setOpenEntity(false)
        setOpenPopper(false)
    }
    //----------------------


    //Onclick Add new Cluster
    const handelEditCluster = () => {
        const body = {
            name: clusterName,
            entity: entity,
            group: group.name
        }
        if (infoPage !== "")
            body.infopage = infoPage.id
        setLoading(true)
        dataProvider('UPDATE', 'clusters', {
            id: clusterData.id,
            data: body
        })
            .then(() => {
                setLoading(false)
                handleClose()
            })
            .catch(error => {
                setLoading(false)
                setError(translate(`resources.room.editFailed`))
            })

    }
    //-------------------



    const getListInfoPage = () => {
        dataProvider('GET_LIST', "info-page-list", {
            filter: {
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setInfopages(data);
                console.log(data.find(item => item.id === clusterData.infopage))
                if (clusterData.infopage && data.find(item => item.id === clusterData.infopage))
                    setInfoPage(data.find(item => item.id === clusterData.infopage))
            })
            .catch(error => {
            })
    }

    const hiddenInfoPage = () => {
        if (!permissions.functionAction.find(value => value.function === 'Cluster info page admin' && value.isRead)) {
            if (!permissions.functionAction.find(value => value.function === 'Cluster info page settings' && value.isRead)) return true
            else return false
        }
        return false
    }

    const disableInfoPage = () => {
        if (!permissions.functionAction.find(value => value.function === 'Cluster info page settings' && value.isCreate)) return true
        return false
    }


    const handleLink = () => {
        localStorage.setItem('selectedInfoPage', infoPage.id)
        history.push('/infoPage');
    }

    const getInfoPageSetting = () => {

        setLoading(true)
        dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Info Page'
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            console.log(data)
            const infoPageData = JSON.parse(data[0].value)
            setInfoPage(infoPageData)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    React.useEffect(() => {
        if (open) {
            getListInfoPage()
            setdisabledEntity(true)
            setCluster(clusterData)
            setEntity(clusterData.entity)
            setGroup({ name: clusterData.group, entity: clusterData.entity })
            // setInfoPage('')
            setError('')
            setFilterCluster('')
            setFilterGroup('')
            setFilterEntity('')
            setClusterName(clusterData.name)
            setOpenClusters(false)
            setOpenEntity(false)
            setOpenGroup(false)
            setOpenInfoPage(false)
        }


    }, [open]);

    useEffect(() => {
        getInfoPageSetting()
    }, [])

    if (!loaded) return null
    if (!clusterData) return null
    return (
        <Box width={500}>
            <Box>
                <Box mb={2} display='flex'>
                    <Box flexGrow={1}>
                        <Typography className={classes.titleCluster}>  {translate(`resources.room.editCluster`)}</Typography>
                    </Box>
                    <Button disabled={readOnly ? true : false} size='small' onClick={handleOpenConfirmDialog}>
                        <img style={{ marginRight: '8px' }} src={DeleteIcon} width='18px' height='18px'></img>
                        <Typography style={{ marginRight: '16px' }} className={classes.TextValue}>{translate('resources.room.deleteCluster')}</Typography>
                    </Button>

                </Box>
                {
                    error != "" && (
                        <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                            <Typography className={classes.TextValue} style={{ color: textColorError, margin: '1em' }}>{error}</Typography>
                        </Box>
                    )
                }
                <CustomTextFiled
                    disabled={readOnly ? true : false}
                    required
                    id="filled-basic"
                    label={translate(`pos.dashboard.name`)}
                    value={clusterName}
                    onChange={onChangeName}
                    style={{ width: 500 }}
                    endDom={
                        <CustomPoper
                            open={openPoper}
                            anchorEl={anchorEl}
                            handleClick={handleClickOpenPoper}
                            handleClose={handleClosePoper}
                            title={translate(`pos.dashboard.name`)}
                            content={translate(`pos.dashboard.constent`)}
                            icon={<b>?</b>}
                        />
                    }
                />
                <Box pt={1} pb={0} mt={1} width={500}>
                    <SelectBox
                        disabled={readOnly ? true : false}
                        required={true}
                        label={translate(`pos.dashboard.selectOrCreateGroup`)}
                        value={group == "" ? "" : group.name}
                        open={openGroup}
                        header={(
                            <Box className={classes.header} display='flex' mb="2px" p={1} bgcolor={colors.lightBlue['200']}>

                                <Box width='40%'><Typography className={classes.TextValue}>Group</Typography></Box>
                                <Box><Typography className={classes.TextValue}>Entity</Typography></Box>
                            </Box>
                        )}
                        filter={(
                            <Box bgcolor="background.paper" p={1} className={classes.boxBoder}>
                                <FilterInput open={openGroup} onChangeValue={onChangeFilterGroup} value={filterGroup} name={translate(`pos.dashboard.group`).toLowerCase()} />
                            </Box>

                        )}
                        CreateBox={
                            <CreateInSelect
                                name={translate(`pos.dashboard.group`).toLowerCase()}
                                valueInput={valueNewGroup}
                                onChangValueInput={onChangNewValueGroup}
                                handelCreateNew={onCreateNewGroup}
                                openCreate={openCreateGroup}
                                handelCancelCreate={handelCancelCreateGroup}
                                clickOpenCreate={clickOpenCreateGroup}
                            />}
                        handleClick={handleClickOpenGroup}
                    >

                        {
                            data.countResult.groups.filter(value => value.name.toUpperCase().search(filterGroup.toUpperCase()) > -1).length === 0
                                ?
                                (
                                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                                        <Typography className={classes.TextValue}>{translate(`pos.dashboard.notfound`)}</Typography>
                                    </Box>
                                )
                                :
                                (
                                    data.countResult.groups.filter(value => value.name.toUpperCase().search(filterGroup.toUpperCase()) > -1).map((row, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeGroup(row)}>
                                                <Box width='100%' display='flex'>
                                                    <Box width='40%'><Typography className={classes.TextValue}>{row.name}</Typography></Box>
                                                    <Box><Typography className={classes.TextValue}>{row.entity != "" && row.entity}</Typography></Box>
                                                </Box>

                                            </ListItem>
                                        </Box>
                                    ))
                                )

                        }
                    </SelectBox>
                </Box>
                <Box pt={1} pb={0} mt={1} width={500}>
                    <SelectBox
                        required={true}
                        disabled={disabledEntity || readOnly ? true : false}
                        label={translate(`pos.dashboard.selectOrCreateEntity`)}
                        value={entity}
                        open={openEntity}
                        CreateBox={
                            <CreateInSelect
                                name={translate(`pos.dashboard.entity`).toLowerCase()}
                                valueInput={valueNewEntity}
                                onChangValueInput={onChangNewValueEntity}
                                handelCreateNew={onCreateNewEntity}
                                openCreate={openCreateEntity}
                                handelCancelCreate={handelCancelCreateEntity}
                                clickOpenCreate={clickOpenCreateEntity}
                            />

                        }
                        handleClick={handleClickOpenEntity}
                    >
                        <Box className={classes.boxBoder}>
                            <ListItem style={{ padding: '8px' }} >
                                <FilterInput open={openEntity} onChangeValue={onChangeFilterEntity} value={filterEntity} name={translate(`pos.dashboard.entity`).toLowerCase()} />
                            </ListItem>
                        </Box>
                        {
                            data.countResult.entities.filter(value => value.name.toUpperCase().search(filterEntity.toUpperCase()) > -1).length === 0 ?
                                (
                                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                                        <Typography className={classes.TextValue}>{translate(`pos.dashboard.notfound`)}</Typography>
                                    </Box>
                                )
                                :
                                (
                                    data.countResult.entities.filter(value => value.name.toUpperCase().search(filterEntity.toUpperCase()) > -1).map((row, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeEntity(row.name)}>
                                                <Typography className={classes.TextValue}>{row.name}</Typography>
                                            </ListItem>
                                        </Box>
                                    ))
                                )

                        }
                    </SelectBox>
                </Box>
                {/* <Box pt={1} pb={0} mt={1} width={500} hidden={hiddenInfoPage()}>
                    <SelectBox
                        disabled={disableInfoPage()}
                        label={translate(`pos.dashboard.selectInfoPage`)}
                        value={infoPage === '' ? '' : infoPage.name}
                        open={openInfoPage}
                        handleClick={handleClickOpenInfoPage}
                        required={true}
                    >
                        <Box className={classes.boxBoder}>
                            <ListItem style={{ padding: '8px' }} >
                                <FilterInput open={openInfoPage} value={filterInfopage} onChangeValue={onChangeFilterInfopage} name={'info page'.toLowerCase()} />
                            </ListItem>
                        </Box>
                        {
                            infopages.filter(value => value.name.toUpperCase().search(filterInfopage.toUpperCase()) > -1).length === 0 ?
                                (
                                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                                        <Typography className={classes.TextValue} >{translate(`pos.dashboard.notfound`)}</Typography>
                                    </Box>

                                )
                                :
                                (
                                    infopages.filter(value => value.name.toUpperCase().search(filterInfopage.toUpperCase()) > -1).map((row, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeInfoPage(row)}>
                                                <Typography className={classes.TextValue}>{row.name}</Typography>
                                            </ListItem>
                                        </Box>
                                    ))
                                )
                        }
                    </SelectBox>
                </Box> */}
                {
                    permissions.functionAction.find(value => value.function === 'Cluster info page admin' && value.isRead) ?
                        <Box display='flex' width='100%' mt={3}>
                            <Typography color='textPrimary' className={classes.link} style={{ cursor: 'pointer', }} onClick={() => { handleLink() }}>{translate('pos.dashboard.goToInfoPage')}</Typography>
                        </Box>
                        : <Box display='flex' width='100%' mt={3}>
                            <Typography className={classes.disabled} style={{ cursor: 'pointer', }} >{translate('pos.dashboard.goToInfoPage')}</Typography>
                        </Box>
                }

                <Box display='flex' width='100%' justifyContent='flex-end' mt={3}>
                    <Box display='flex' alignItems='flex-end' mr={3}>
                        <TextButton onClick={handleClose} />

                    </Box>
                    <Button variant="contained" color='primary' className={classes.btnCreateCluster} onClick={handelEditCluster} disabled={clusterName == "" || group == "" || entity == "" || readOnly ? true : false}>
                        {loading ? (
                            <CircularProgress
                                size={15}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            translate(`resources.room.save`)
                        }
                    </Button>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={handleCloseConfirmDialog}
                handleConfirm={handleDeleteCluster}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('resources.room.deleteCluster')} />
        </Box>

    );
}
export default General